import { BrowserRouter, Route, Routes } from "react-router-dom";
import TopNav from "./components/top-nav";
import ScrolledNav from "./components/scrolled-nav";
import Home from './pages/home/home';
import AboutUs from './pages/about-us/about-us';
import Practices from './pages/practices/practices';
import Feedback from './pages/feedback/feedback';
import Careers from './pages/careers/careers';
import ContactUs from './pages/contact-us/contact-us';
import Footer from "./components/footer";
import PostDetails from "./pages/practices/component/post-details";
import AboveNav from "./components/above-nav";
import BottomFooter from "./components/bottom-footer";
import { useEffect, useState } from "react";
import Preloader from "./components/preloader";
import FloatingMessenger from "./components/floating-messenger";

function App() {

  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const handleLoad = () => setIsLoaded(true);

    // Wait for all assets (images, fonts, etc.)
    if (document.readyState === "complete") {
      setIsLoaded(true);
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => window.removeEventListener("load", handleLoad);
  }, []);

  if (!isLoaded) {
    return <Preloader />;
  }


  return (
    <BrowserRouter>
      <div className="font-fontLato">
        <FloatingMessenger />
        <AboveNav />
        <ScrolledNav/>
        <TopNav />
          <Routes>
            <Route path='/' element={<Home />}></Route>
            <Route path='/about/' element={<AboutUs />}></Route>
            <Route path='/practices/' element={<Practices />}></Route>
            <Route path='/careers/' element={<Careers />}></Route>
            <Route path='/feedback/' element={<Feedback />}></Route>
            <Route path='/contact/' element={<ContactUs />}></Route>
            <Route path='/practices/posts/:slug' element={<PostDetails />}></Route>
          </Routes>
        <Footer/>
      </div>
    </BrowserRouter>
  );
}

export default App;
